














import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import Default from '../components/common/Default.vue'
import { ActionSignIn } from '../store/user/types'
import { ErrorMessage, Page } from '../type'
import LoadingModal from '../components/common/LoadingModal.vue'

const UserModule = namespace('user')

@Component({ components: { Default, LoadingModal } })
export default class Signin extends Vue {
  @UserModule.Action('signin') signin!: ActionSignIn
  @UserModule.Getter('signedIn') signedIn!: boolean
  loading = false
  error = ''
  redirect = Page.Mypage

  mounted() {
    const redirect = this.$route.query.redirect
    if (
      typeof redirect === 'string' &&
      (Object.values(Page) as string[]).includes(redirect)
    )
      this.redirect = redirect as Page
    if (this.signedIn) this.$router.push({ name: this.redirect })
  }

  handleSignin() {
    this.loading = true
    this.signin()
      .then(() => {
        this.$router.push({ name: this.redirect })
      })
      .catch((e: Error) => {
        if (e.message === ErrorMessage.UserNotFound) {
          this.error = 'このアカウントは登録されていません'
        }
      })
      .finally(() => {
        this.loading = false
      })
  }
}
